import {Model, PrivacyStatement} from '../Models';
import {AddressTypeEnum, TitleEnum} from '../Enums';
import {LocalStorageObject} from '../Utilities';
import {DataTransferObject} from './DataTransferObject';
import {VisitorSurveyResultDTO} from './VisitorSurveyResultDTO';
import {PublicTransportConfigDTO} from './PublicTransportConfigDTO';
import {AdditionalNotice} from '../Models/AdditionalNotice';

export class CustomerDataDTO extends DataTransferObject implements LocalStorageObject {
  accountCode: number | null = null; // not available on guest login
  zbdId: number | null = null; // not available on guest login
  salutation: number | null = null;
  title: number = TitleEnum.NONE.value;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  emailConfirm: string = '';
  street: string = '';
  houseNr: string = '';
  company: string = '';
  additionalInformation: string = '';
  zip: string = '';
  city: string = '';
  state: number | null = null;
  country: number | null = null;

  addressType: number = AddressTypeEnum.NONE.value;
  usePublicTransport: boolean = false;
  publicTransportConfigs: Array<PublicTransportConfigDTO> = [];
  paymentOption: string | null = null;
  useInvoiceAddress: boolean = false;
  surveys: { [key: string]: VisitorSurveyResultDTO } = {};
  additionalNotices: Array<AdditionalNotice> = [];

  fallbackPrivacyChecked: boolean = false;
  fallbackAgbChecked: boolean = false;

  // filled when checking the boxes per client on last checkout step
  privacyStatements: Array<PrivacyStatement> = [];
  termsAndConditions: Array<any> = [];

  fromStorage(data: any) {
    return this.fromData(data);
  }

  /**
   * unused, actually no model, see fromData below
   * @deprecated
   * @param model
   */
  fromModel(model: Model): CustomerDataDTO {
    return this.fromData(model);
  }

  /**
   * Fill with buyerData or invoiceData of order model
   * @param data
   */
  fromData(data: any): CustomerDataDTO {
    const customerDataDTO = new CustomerDataDTO();
    customerDataDTO.accountCode = CustomerDataDTO.notSet(data.accountCode) ? this.accountCode : data.accountCode;
    customerDataDTO.zbdId = CustomerDataDTO.notSet(data.zbdId) ? this.zbdId : data.zbdId;
    customerDataDTO.salutation = CustomerDataDTO.notSet(data.salutation) ? this.salutation : data.salutation;
    customerDataDTO.title = CustomerDataDTO.notSet(data.title) ? this.title : data.title;
    customerDataDTO.firstName = CustomerDataDTO.notSet(data.firstName) ? this.firstName : data.firstName;
    customerDataDTO.lastName = CustomerDataDTO.notSet(data.lastName) ? this.lastName : data.lastName;
    customerDataDTO.email = CustomerDataDTO.notSet(data.email) ? this.email : data.email;
    customerDataDTO.street = CustomerDataDTO.notSet(data.street) ? this.street : data.street;
    customerDataDTO.houseNr = CustomerDataDTO.notSet(data.houseNr) ? this.houseNr : data.houseNr;
    customerDataDTO.company = CustomerDataDTO.notSet(data.company) ? this.company : data.company;
    customerDataDTO.additionalInformation = CustomerDataDTO.notSet(data.additionalInformation) ? this.additionalInformation : data.additionalInformation;
    customerDataDTO.zip = CustomerDataDTO.notSet(data.zip) ? this.zip : data.zip;
    customerDataDTO.city = CustomerDataDTO.notSet(data.city) ? this.city : data.city;
    customerDataDTO.state = CustomerDataDTO.notSet(data.state) ? this.state : data.state;
    customerDataDTO.country = CustomerDataDTO.notSet(data.country) ? this.country : data.country;

    customerDataDTO.fallbackPrivacyChecked = CustomerDataDTO.notSet(data.fallbackPrivacyChecked) ? this.fallbackPrivacyChecked : data.fallbackPrivacyChecked;
    customerDataDTO.fallbackAgbChecked = CustomerDataDTO.notSet(data.fallbackAgbChecked) ? this.fallbackAgbChecked : data.fallbackAgbChecked;
    customerDataDTO.privacyStatements = CustomerDataDTO.notSet(data.privacyStatements) ? this.privacyStatements : data.privacyStatements;
    customerDataDTO.termsAndConditions = CustomerDataDTO.notSet(data.termsAndConditions) ? this.termsAndConditions : data.termsAndConditions;
    if (CustomerDataDTO.notSet(data.addressType) && data.customerRole) {
      customerDataDTO.addressType = data.customerRole;
    } else {
      customerDataDTO.addressType = CustomerDataDTO.notSet(data.addressType) ? this.addressType : data.addressType;
    }
    customerDataDTO.usePublicTransport = CustomerDataDTO.notSet(data.usePublicTransport) ? this.usePublicTransport : data.usePublicTransport;
    let pubTransConfigData = CustomerDataDTO.notSet(data.publicTransportConfigs) ? this.publicTransportConfigs : data.publicTransportConfigs;
    pubTransConfigData = pubTransConfigData.filter(
      configData => customerDataDTO.usePublicTransport
        && configData.usePubTrans
        && (configData.date !== null || (configData.from !== null && configData.to !== null)),
    );
    customerDataDTO.publicTransportConfigs = pubTransConfigData.map(d => (new PublicTransportConfigDTO()).fromData(d));
    customerDataDTO.paymentOption = CustomerDataDTO.notSet(data.paymentOption) ? this.paymentOption : data.paymentOption;
    customerDataDTO.useInvoiceAddress = CustomerDataDTO.notSet(data.useInvoiceAddress) ? this.useInvoiceAddress : data.useInvoiceAddress;
    const surveys = {};
    if (data.surveys && Object.keys(data.surveys).length > 0) {
      Object.keys(data.surveys).forEach(k => {
        surveys[k] = (new VisitorSurveyResultDTO()).fromData(data.surveys[k]);
      });
    }
    customerDataDTO.surveys = surveys;
    customerDataDTO.additionalNotices = CustomerDataDTO.notSet(data.additionalNotices) ? this.additionalNotices : data.additionalNotices;
    return customerDataDTO;
  }

  private static notSet(value: any): boolean {
    return value === undefined || value === null;
  }
}
